import ApiHttp from "byzantine/src/ApiHttp";
import {
  BankingTokenRecord,
  CreatedBankingTokenRecord,
  DeserializedBankingToken,
  PaginatedBankingTokenResponse,
} from "./types";

export function createBankingToken(submitData: {
  nickname: string;
  ip_allowlist: string[];
}): Promise<CreatedBankingTokenRecord> {
  return ApiHttp.fetch(
    "banking/tokens/",
    { method: "POST" },
    { ...submitData },
  );
}

export function listBankingTokens(): Promise<PaginatedBankingTokenResponse> {
  return ApiHttp.fetch("banking/tokens/", { method: "GET" });
}

export function retrieveBankingToken(
  uuid: string,
): Promise<BankingTokenRecord> {
  return ApiHttp.fetch(`banking/tokens/${uuid}/`, { method: "GET" });
}

export function updateBankingToken(
  uuid: string,
  submitData: {
    nickname: string;
    ip_allowlist: string[];
  },
): Promise<BankingTokenRecord> {
  return ApiHttp.fetch(
    `banking/tokens/${uuid}/`,
    { method: "PUT" },
    { ...submitData },
  );
}

export async function destroyBankingToken(
  uuid: string,
): Promise<BankingTokenRecord> {
  await ApiHttp.fetch(`banking/tokens/${uuid}/`, { method: "DELETE" });
  return retrieveBankingToken(uuid);
}

function formatTimestamp(timestamp: string | null) {
  if (!timestamp) return "N/A";
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return "N/A";
  return date.toLocaleString(undefined, {
    year: "2-digit",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

export function deserializeBankingToken(
  token: BankingTokenRecord | CreatedBankingTokenRecord,
): DeserializedBankingToken {
  return {
    uuid: token.uuid,
    nickname: token.nickname,
    lastUsed: formatTimestamp(token.last_used),
    created: formatTimestamp(token.created),
    expires: formatTimestamp(token.expires),
    isExpired: new Date(token.expires) < new Date(),
    createdBy: token.username,
    ipAllowlist: token.ip_allowlist,
    ipAllowListDisplay: `${token.ip_allowlist.length} IPs allowed`,
  };
}
